module.exports = __webpack_public_path__ + "img/keymaker__logo.a3523dce.svg";